import React from 'react';

import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Text } from 'ui';

const List = ({
  children,
  ordered = false,
  hasOffsets = false,
  className,
  ...attrs
}) => (
  <Text
    tag={ordered ? 'ol' : 'ul'}
    className={cn(
      'typography-list',
      {
        'typography-list--numeric': ordered,
        'typography-list--offsets': hasOffsets,
      },
      className
    )}
    {...attrs}
  >
    {children}
  </Text>
);

List.displayName = 'List';
List.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default List;
